// @ts-check
/**
 * @file useBootHousekeeping.js
 * @location src/hooks/useBootHousekeeping.js
 * @role App 마운트 시 1회 housekeeping. 세션 시작마다 1번.
 *   AUTO_GENERATE_RECURRING(반복업무 오늘 발생분) · AUTO_CARRY_OVER(받음완료·기한경과 다음 영업일 이월)
 *   · AUTO_PURGE_TRASH(휴지통 30일 경과 silent 영구삭제).
 *
 *   ⚠️ 온라인(Supabase) 모드에선 셋 다 서버 권위 — generate-recurring Edge Function·app.carry_over()·
 *   app.purge_trash() 가 pg_cron 으로 실행하고 HYDRATE 가 서버본을 가져온다. 여기 클라 디스패치는
 *   오프라인/VITE_E2E 로컬부팅용 멱등 폴백(HYDRATE 후 dedupe 로 no-op). 서버=SoT.
 */
import { useEffect } from 'react';
import { getTodayStr, isClosed } from '../data/constants.js';

/**
 * @param {object} p
 * @param {import('../data/types.js').Task[]} p.tasks
 * @param {(type: string, patch?: object) => void} p.act
 * @param {(msg: string, kind?: string) => void} p.showToast
 */
export function useBootHousekeeping({ tasks, act, showToast }) {
  useEffect(() => {
    const today = getTodayStr();
    // 반복 업무 — 오늘 발생분 자동 생성·할당 (받음 전 안 읽음 직행)
    act('AUTO_GENERATE_RECURRING');
    const msgs = [];

    // 받음 razor — 받음(읽음) 안 한 task 는 carry-over 대상 외 (reducer 가드와 동일 조건)
    const carryCount = tasks.filter(t =>
      t.due && t.due < today && !isClosed(t.status) && t.acknowledgedAt
    ).length;
    if (carryCount > 0) {
      act('AUTO_CARRY_OVER');
      msgs.push(`${carryCount}건을 다음 영업일로 이월`);
    }

    // 휴지통 30일 경과 자동 영구 삭제 — 토스트 없음 (silent)
    act('AUTO_PURGE_TRASH');

    if (msgs.length) showToast(msgs.join(' / '));
    // reason: mount-only boot — 세션 시작 시 1회 housekeeping. tasks 변경마다 재실행 X.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
